import {
    FOLDER_CONFIRMED_ACTION,
    FOLDER_FAILED_ACTION,
    OKTA_USER_SEARCH_CONFIRMED_ACTION,
    OKTA_USER_SEARCH_FAILED_ACTION,
    UPLOAD_CONFIRMED_ACTION,
    UPLOAD_FAILED_ACTION
} from "../actions/actionTypes";

const initialState = {
    data: [],
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export function BoxReducer(state = initialState, action) {
    if (action.type === FOLDER_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'Folders fetch successfully',
            showLoading: false,
        };
    } else if (action.type === UPLOAD_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'Upload Successfully Completed',
            showLoading: false,
        };
    } else if (action.type === OKTA_USER_SEARCH_CONFIRMED_ACTION) {
        return {
            ...state,
            data: action.payload,
            errorMessage: '',
            successMessage: 'Employee Search Successfully Completed',
            showLoading: false,
        };
    } else if (
        action.type === FOLDER_FAILED_ACTION ||
        action.type === UPLOAD_FAILED_ACTION ||
        action.type === OKTA_USER_SEARCH_FAILED_ACTION 
    ) {
        return {
            ...state,
            errorMessage: action.payload,
            successMessage: '',
            showLoading: false,
        };
    } else {
        return state;
    }


}


